import { Component, Input, Output, EventEmitter, ChangeDetectorRef, forwardRef, HostListener, } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrl: './custom-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDropdownComponent),
      multi: true,
    },
  ],
})
export class CustomDropdownComponent implements ControlValueAccessor {
  @Input() options: Array<any> = [];
  @Input() placeholder!: string;
  @Input() ngModel: any; // Bound model (string, number, or object)
  @Input() optionsText!: string; // Field to display as the label
  @Input() optionsValue!: string; // Field to use as the bound value
  @Input() textSuffix!: string; // Suffix to display after the selected option
  @Output() ngModelChange = new EventEmitter<any>();

  public dropdownOpen: boolean = false;
  public searchText!: string | undefined; // Search input value
  public filteredOptions: Array<any> = []; // Filtered options to display

  private static openDropdown: CustomDropdownComponent | null = null;
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.filteredOptions = [...this.options]; // Initialize with all options
  }

  toggleDropdown(event: Event) {
    if (CustomDropdownComponent.openDropdown && CustomDropdownComponent.openDropdown !== this) {
      CustomDropdownComponent.openDropdown.closeDropdown();
    }
    this.dropdownOpen = !this.dropdownOpen;
    CustomDropdownComponent.openDropdown = this.dropdownOpen ? this : null;

    if (this.dropdownOpen) {
      this.searchText = ''; // Reset search input when opening
      this.filteredOptions = [...this.options];
    }

    //event.stopPropagation();
    this.cdr.detectChanges();
  }

  closeDropdown() {
    this.dropdownOpen = false;
    this.cdr.detectChanges();
  }

  selectOption(option: any | null, event: Event) {
    event.stopPropagation();
    if (!option || option == 0) {
      option = { [this.optionsText]: 'Select an option', [this.optionsValue]: null };
    }
    this.ngModel = option[this.optionsValue];
    this.onChange(this.ngModel);
    this.ngModelChange.emit(this.ngModel);

    this.dropdownOpen = false;
    CustomDropdownComponent.openDropdown = null;
    this.cdr.detectChanges();
  }

  filterOptions() {
    this.dropdownOpen = true;
    CustomDropdownComponent.openDropdown = this.dropdownOpen ? this : null;

    if (this.searchText) {
      const searchLower = this.searchText.toLowerCase();
      this.filteredOptions = this.options.filter((option) =>
        this.getOptionText(option).toLowerCase().includes(searchLower)
      );
    }
    else {
      this.filteredOptions = [...this.options];
    }

    if (this.filteredOptions.length == 1) {
      let selectedOption = this.filteredOptions[0];
      this.selectOption(selectedOption, new Event('click'));
    }

  }

  NoMatchingOptions( event: Event) {
    event.stopPropagation();
    this.ngModel = { [this.optionsText]: 'Select an option', [this.optionsValue]: 0 };
    this.ngModelChange.emit(this.ngModel);

    this.dropdownOpen = false;
    CustomDropdownComponent.openDropdown = null;
    this.cdr.detectChanges();
  }

  getOptionText(option: any): string {
    const optionText = this.optionsText.split('.').reduce((o, i) => o[i], option) || '';
    return this.textSuffix ? `${optionText}${this.textSuffix}` : optionText;
  }

  getOptionValue(option: any): any {
    return this.optionsValue.split('.').reduce((o, i) => o[i], option) || '';
  }

  getSelectedLabel(): string | undefined {
    const selectedOption = this.options.find(option => this.getOptionValue(option) === this.ngModel);
    this.searchText = selectedOption ? this.getOptionText(selectedOption) : undefined;
    return selectedOption ? this.getOptionText(selectedOption) : undefined;
  }

  writeValue(value: any): void {
    this.ngModel = value;
    this.cdr.detectChanges();
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabled state if necessary
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.form-group')) {
      this.closeDropdown();
      CustomDropdownComponent.openDropdown = null;
    }
  }
}
